export default __webpack_public_path__ + "static/media/arrow.5fddd94f.svg";